<template>
	<div class="operation-fractions-component">
		<span class="left-hand-operation">
			<span class="operands">
				<div v-for="(operand, i) in operands" class="operand">
					<fraction-component :fraction="evaluate(operand)"></fraction-component>
					<span class="operator" v-if="i<operands.length-1">{{operator}}</span>
				</div>
			</span>
		</span>
		<span class="details">
			<span v-if="showDetails">
				<span v-for="(fract, j) in extras" class="flex-center flex-nowrap">
					<div class="equal-operator">=</div>
					<span v-if="fract.isOperation" class="flex-center">
						<span class="flex-center" v-for="(fr,k) in fract.operands">
							<fraction-component :fraction="fr" :key="hash(fr)"></fraction-component>
							<span v-if="k<fract.operands.length-1">{{ fract.operator }}</span>
						</span>
					</span>
					<span :is="make_component(fract)"></span>
					<!-- <fraction-component v-else :fraction="fract" class="mx-1" :key="hash(fract)"></fraction-component> -->
					<span class="equal-operator" v-if="j==0">=</span>
				</span>
				</span>
			</span>
		<fraction-component :fraction="result" class="fraction-result"></fraction-component>
	</div>
</template>

<script type="text/javascript">
	const Fraction=require('../scripts/Fraction');
	const $operations=require("../scripts/variables").operations;
	import FractionComponent from '../FractionComponent.vue';
	import BaseExerciseMixin from '../../js/BaseExerciseMixin.js';
	export default{
		name:'operation-fraction',
		mixins:[BaseExerciseMixin],
		components:{FractionComponent},
		props:{
			terms:{type:Array, required:true},
			operator:{type:String, required:false,default:'+'},
			showDetails:{type:Boolean, required:false, default:true}
		},
		data(){
			return {
				operands:this.terms,
			}
		},
		created(){
			let result=$operations.unknow(this.operator,this.terms);
			this.extras=result.extras||[];
			this.operands=this.terms;
			this.result=result;
		},
		methods:{
			evaluate(elt){
				return new Fraction(elt);
			},
			make_component(data){
				return {
					template:this.tag('span',data),
					components:{FractionComponent}
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.operation-fractions-component{
		display: flex;
		align-items: flex-start;

		.left-hand-operation{
			.operands{
				display: flex;
				align-items:center
				.operand{
					display: flex;
					justify-content: around;
					align-items:center;
				}
			}
		}
		.equal-operator{
		}
		.fraction-result{
			border: 1px solid green;
			color: lightblue;
		}
		.pgcd{
			color:#fe3333;
		}
	}
</style>